export enum TAG_NAME {
  NEWS_TITLE = 'newsTitle',
  BANNER = 'banner',
  TVSHOWS = 'tvshows',
  TOP_TEN = 'top10',
  APP_COVER = 'app_cover',
  COVER = 'cover',
  EPISODES = 'episodes',
  LIST = 'list',
  LIST_BIG = 'listBig',
  CONTINUE_WATCHING = 'continueWatching',
  COLLECTION = 'collection',
  RECOMMENDED_ARTIST = 'recommendedArtist',
  PORTRAIT_SMALL = 'portraitSmall',
  PORTRAIT_UNDERSCORE_LARGE = 'portrait_large',
  PORTRAIT_UNDERSCORE_SMALL = 'portrait_small',
  SAME_EPISODE_LIST = 'sameepisodelist',
  PORTRAIT_SMALL_BG = 'portraitSmallBg',
  NEWS_COLLECTION = 'newsCollection',
  NEWS_UNDERSCORE_TITLE = 'news_title',
  DIFFERENT_EPISODE_LIST = 'differentepisodelist',
  PORTRAIT = 'portrait',
  PLAYER_POSTER = 'playerPoster',
  SHOW_DETAIL_BANNER = 'showDetail',
  PORTRAIT_LARGE = 'portraitLarge',
  ZEE5_MUSIC_ENTRYPOINT_BANNER = 'zee5_music_entrypoint_banner',
  ZEE5MUSICENTRYPOINTBANNER = 'zee5MusicEntrypointBanner',
  ZEE5MUSIC = 'zee5Music'
}
